<template>
  <div @click="$emit('click')" style="cursor: pointer; display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 512 512"
    >
      <path
        :fill="isDarkTheme ? headingTextColor : '#ffffff'"
        :stroke="isDarkTheme ? headingTextColor : '#ffffff'"
        stroke-width="35"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M112 111v290c0 17.44 17 28.52 31 20.16l247.9-148.37c12.12-7.25 12.12-26.33 0-33.58L143 90.84c-14-8.36-31 2.72-31 20.16z"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: "PlayIcon",
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    }
  }
};
</script>
<style scoped>
/* div:hover {
  opacity: 0.7;
  transition: opacity 0.2s;
} */
</style>
